import { useState, useEffect, useCallback } from 'react';

/**
 * Custom hook that tracks mouse position and provides
 * normalized coordinates for magnetic/parallax effects.
 * Returns { x, y } normalized to -1..1 from center of viewport
 * and raw { clientX, clientY } for absolute positioning.
 */
export default function useMouseParallax() {
  const [mouse, setMouse] = useState({
    x: 0,
    y: 0,
    clientX: 0,
    clientY: 0,
  });

  const handleMouseMove = useCallback((e) => {
    const { clientX, clientY } = e;
    const { innerWidth, innerHeight } = window;

    // Normalize to -1 to 1
    const x = (clientX / innerWidth - 0.5) * 2;
    const y = (clientY / innerHeight - 0.5) * 2;

    setMouse({ x, y, clientX, clientY });
  }, []);

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [handleMouseMove]);

  return mouse;
}
